import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class MRIEditerService {
  public uiGridWasChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
}
